module.exports = __webpack_public_path__ + "img/schnittkante_kobaltblau_ral5013.c25b62b5.jpg";